module.exports = __webpack_public_path__ + "static/cross-05b7d0c40f80165429b4e6dc64aa34da.png";